App.controller('confirmCtrl', ( $scope ) => {
  $scope.title = $scope.ngDialogData.title
  $scope.text = $scope.ngDialogData.text
  $scope.subhead = $scope.ngDialogData.subhead
  $scope.custom_confirm = $scope.ngDialogData.custom_confirm
  $scope.custom_cancel = $scope.ngDialogData.custom_cancel
})
